/**
 * Initialize
 */

$(document).on("ready", function () {
  fw_init();
  var resizeTimer;
  $(window).on("resize", function (e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      fw_init();
    }, 250);
  });
});
